module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product10-8f738e26426c0ecedc55f10d914735db.jpg";